import serves from "@/http";
// import * as storage from "../storage";
import * as types from "./mutations-type";
export const ActionCadastro = ({dispatch},payload)=>{
    return serves.rescisaocontrator.cadastra(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionRescisaoCadastro = ({dispatch},payload)=>{
    return serves.rescisaocontrator.rescisaocadastra(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionDeletar = ({dispatch},payload)=>{
    return serves.rescisaocontrator.delete(payload).then(res => {
        console.log(res);
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',res)
    })
}
export const ActionLista = ({dispatch},payload)=>{
    return serves.rescisaocontrator.lista(payload).then(res => {
        dispatch('ActionSetLista',res)
    }).catch(err => {
        dispatch('ActionSetLista',res)
    })
}
export const ActionEditar = ({dispatch},payload)=>{
    return serves.rescisaocontrator.editar(payload).then(res => {
        dispatch('ActionSetEditar',res)
    }).catch(err => {
        dispatch('ActionSetEditar',err)
    })
}
export const ActionUpdate = ({dispatch},payload)=>{
    return serves.rescisaocontrator.update(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionRescisaoUpdate = ({dispatch},payload)=>{
    return serves.rescisaocontrator.rescisaoupdate(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionEvento = ({dispatch},payload)=>{
    return serves.rescisaocontrator.evento(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}

export const ActionEventoCadastro = ({dispatch},payload)=>{
    return serves.rescisaocontrator.eventocadastra(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionSetMsg = ({commit},payload) =>{
    commit(types.SET_MSG,payload)
}
export const ActionSetEditar = ({commit},payload) =>{
    commit(types.SET_EDITAR,payload)
}

export const ActionSetLista = ({commit},payload) =>{
    commit(types.SET_LISTA,payload)
}
export const ActionSetId = ({commit},payload) =>{
    commit(types.SET_ID,payload)
}